import {useFormik} from 'formik';
import loginSchema from '../../../validators/Login';
import {Button, Input} from '../..';
import {Box, createStyles, Grid, Link, Theme} from '@material-ui/core';
import {AuthErrorReason} from '../../../types/auth';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';
import {FORGOT_PASSWORD_PAGE} from '../../../const/routes';
import {useHistory} from 'react-router';
import {makeStyles} from "@material-ui/styles";
import { BACKGROUND_SECONDARY } from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        input: {
            backgroundColor: BACKGROUND_SECONDARY,
        },
        buttonsWrapper: {
            marginTop: 24,
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            flexDirection: 'column',
        },
        loginButton: {
            width: 300,
        },
        microsoftButton: {
            marginTop: 16,
            backgroundColor: '#ffffff',
            border: '1px #8c8c8c solid',
            '&:hover': {
                backgroundColor: '#f4f4f4f4'
            },
            width: 300,
            fontWeight: 'bold',
            // [theme.breakpoints.up('lg')]: {
            //     width: 327,
            // }
        },
        [theme.breakpoints.down('md')]: {
            loginButton: {
                width: '100%',
            },
            microsoftButton: {
                width: '100%',
            }
        }
    })
);

type Props = {
    onSubmit: (values: {email: string; password: string}) => void;
    onClickMicrosoft: () => void;
    error?: AuthErrorReason;
};

const LoginForm = ({onSubmit, error, onClickMicrosoft}: Props) => {
    const classes = useStyles();
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: loginSchema,
        onSubmit,
    });
    const {t} = useTranslation(i18nNamespaces.AUTH);
    const history = useHistory();

    const loginError =
        error === 'INVALID_EMAIL_OR_PASSWORD'
            ? t('invalidEmailOrPassword')
            : error === 'OTHER_ERROR' && t('loginError');

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                    <Input
                        fullWidth
                        style={{display: 'flex'}}
                        type="text"
                        id="email"
                        name="email"
                        errorText={formik.touched.email && formik.errors.email}
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        label="E-mail"
                        className={classes.input}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Input
                        fullWidth
                        style={{display: 'flex'}}
                        type="password"
                        id="password"
                        name="password"
                        errorText={
                            formik.touched.password && formik.errors.password
                        }
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        label={t('password')}
                        className={classes.input}
                    />
                    <Link
                        color={'secondary'}
                        onClick={() => history.push(FORGOT_PASSWORD_PAGE)}
                        style={{cursor: 'pointer', marginTop: 8, display: 'inline-block'}}
                    >
                        {t('dontRememberThePassword')}
                    </Link>
                </Grid>
                {loginError && (
                    <Grid item xs={12}>
                        <Box component="span" color="red">
                            {loginError}
                        </Box>
                    </Grid>
                )}
            </Grid>
            <Box className={classes.buttonsWrapper}>
                <Button
                    variant={'contained'}
                    color={'secondary'}
                    type={'submit'}
                    className={classes.loginButton}
                >
                    {t('logIn')}
                </Button>
                <Button
                    onClick={onClickMicrosoft}
                    className={
                        classes.microsoftButton
                    }
                    startIcon={
                        <img
                            src={
                                'https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.svg'
                            }
                        />
                    }
                >
                    {t('loginByMicrosoft')}
                </Button>
            </Box>
        </form>
    );
};

export default LoginForm;
